import { QuoteBoard } from "~/features/quote-board/index.tsx";

export const QuoteBoardPage = () => {
	return <QuoteBoard />;
};
